// extracted by mini-css-extract-plugin
export default {"root":"m4meoxNlTBOH4LlZS7t0","wrap":"lHOggjnOgRP1LfyqNG1q","rec":"mLgQWwkxEgPiVKiThuJ4","icon":"lsvCwawoFvTA9adLMn41"};